import * as logLevel from 'loglevel'
import dotEnv from "dotenv";
import {ReactAppMode} from "./Interfaces/ReactAppModes";
import {ReactIntegrationMode} from "./Interfaces/ReactIntegrationMode";

export const loadEnvVariables = () => {
    dotEnv.config();

    let path;
    switch (process.env.NODE_ENV) {
        case "test":
            path = `../.env.test`;
            break;
        case "production":
            path = `../.env.production`;
            break;
        default:
            path = `../.env.development`;
            break;
    }
    dotEnv.config({path: path});
};

export const setupLogLevel = (props: any) => {
    if (isNotEnvVarSet(process.env.REACT_APP_LOG_LEVEL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["logLevel"]) {
            logLevel.setLevel(props["logLevel"]);
        } else {
            logLevel.setLevel('warn');
        }
    } else {
        switch ((process.env.REACT_APP_LOG_LEVEL || "").toLowerCase()) {
            case 'trace': {
                logLevel.setLevel('trace');
                break;
            }
            case 'debug': {
                logLevel.setLevel('debug');
                break;
            }
            case 'info': {
                logLevel.setLevel('info');
                break;
            }
            case 'warn': {
                logLevel.setLevel('warn');
                break;
            }
            case 'error': {
                logLevel.setLevel('error');
                break;
            }
            case 'silent': {
                logLevel.setLevel('silent');
                break;
            }
            default:
                logLevel.setLevel('warn');
        }
    }
};

export let EXPERIENCE_API_URL = "";
export let RESERVATION_API_URL = "";
export let AUTO_ADJUST_API_URL = "";
export let RESERVATION_BOOK_API_URL = "";
export let USER_CONTRACTS_API_URL = "";
export let JAHIA_CONTENT_API_URL = "";
export let JAHIA_ROOMS_API_URL = "";
export let OWNER_PROFILE_API_URL = "";
export let OWNER_PROPERTIES_API_URL = "";
export let RESERVATION_DETAIL_API_URL = "";
export let AYP_URL = "";
export let API_CALL_TIMEOUT = "60000";
export let RESERVATION_LIST_API_URL = "";
export let RESERVATION_DETAIL_API_URL_WEEKS = "";
export let COUNTRY_LIST_API_URL = "";
export let ADS_API = "";
export let POINTS_CALCULATOR_API_URL = "";
export let TRANSACTION_LIST_API_URL = "";
export let OWNER_INFO_API_URL = "";
export let CHECK_ELIGIBILITY_URL = "";
export let WAITLIST_MANAGEMENT_LIST_API_URL = "";
export let WAITLISTS_CREATE_API_URL = "";
export let WAITLIST_API_URL = "";
export let WAITLISTS_AYP_URL = "";
export let WAITLIST_SUMMARY_REVIEW_URL = "";
export let GUEST_TERMS_API_URL = "";
export let APP_DYNAMICS_KEY = "";
export let GUEST_PROFIEL_URL = "";
export let TRANSFER_POINTS_CONTRACTS_URL = "";
export let EXEC_MODE = ReactAppMode.LOCAL;
export let INTEGRATION_MODE = ReactIntegrationMode.VOA;

const isNotEnvVarSet = (envVar: string | undefined) => {
    return envVar === undefined || envVar.length === 0 || envVar.indexOf('$') >= 0;
};

export let execMode = () => {
    let mode = process.env.REACT_APP_MODE as ReactAppMode;
    if (isNotEnvVarSet(mode)) {
        if (process.env.NODE_ENV === "production") {
            EXEC_MODE = ReactAppMode.VCAP;
        }
    } else {
        EXEC_MODE = mode;
    }
}


const constructApiUrl = (apiUrl: string) => {
    if ([ReactIntegrationMode.AC, ReactIntegrationMode.VSE].includes(INTEGRATION_MODE)) {
        return apiUrl.replace('/voa', '');
    }

    return apiUrl;
};

export const configApiCalls = (props: any) => {
    INTEGRATION_MODE = props["integrationMode"];

    if (isNotEnvVarSet(process.env.REACT_APP_EXPERIENCE_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiUrl"]) {
            EXPERIENCE_API_URL = props["apiUrl"];
        }
    } else {
        EXPERIENCE_API_URL = constructApiUrl(process.env.REACT_APP_EXPERIENCE_API_URL || '');
    }

    if (isNotEnvVarSet(process.env.REACT_APP_CHECK_ELIGIBILITY_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["checkEligibilityUrl"]) {
            CHECK_ELIGIBILITY_URL = props["checkEligibilityUrl"];
        }
    } else {
        CHECK_ELIGIBILITY_URL = constructApiUrl( process.env.REACT_APP_CHECK_ELIGIBILITY_URL || '');
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiResUrl"]) {
            RESERVATION_API_URL = props["apiResUrl"];
        }
    } else {
        RESERVATION_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_AUTO_ADJUST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiAutoAdjustUrl"]) {
            AUTO_ADJUST_API_URL = props["apiAutoAdjustUrl"];
        }
    } else {
        AUTO_ADJUST_API_URL = constructApiUrl( process.env.REACT_APP_AUTO_ADJUST_API_URL || '');
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_BOOK_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiBookUrl"]) {
            RESERVATION_BOOK_API_URL = props["apiBookUrl"];
        }
    } else {
        RESERVATION_BOOK_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_BOOK_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_WAITLIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiWaitlistUrl"]) {
            WAITLIST_API_URL = props["apiWaitlistUrl"];
        }
    } else {
        WAITLIST_API_URL = constructApiUrl( process.env.REACT_APP_WAITLIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_USER_CONTRACTS_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiUserContractsUrl"]) {
            USER_CONTRACTS_API_URL = props["apiUserContractsUrl"];
        }
    } else {
        USER_CONTRACTS_API_URL = constructApiUrl( process.env.REACT_APP_USER_CONTRACTS_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_JAHIA_CONTENT_API_BASE_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["jahiaContentApiUrl"]) {
            JAHIA_CONTENT_API_URL = props["jahiaContentApiUrl"];
        }
    } else {
        JAHIA_CONTENT_API_URL = constructApiUrl( process.env.REACT_APP_JAHIA_CONTENT_API_BASE_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_JAHIA_ROOMS_API_BASE_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["jahiaRoomsApiUrl"]) {
            JAHIA_ROOMS_API_URL = props["jahiaRoomsApiUrl"];
        }
    } else {
        JAHIA_ROOMS_API_URL = constructApiUrl( process.env.REACT_APP_JAHIA_ROOMS_API_BASE_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_OWNER_PROFILE_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiOwnerProfileUrl"]) {
            OWNER_PROFILE_API_URL = props["apiOwnerProfileUrl"];
        }
    } else {
        OWNER_PROFILE_API_URL = constructApiUrl( process.env.REACT_APP_OWNER_PROFILE_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_AYP_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["aypUrl"]) {
            AYP_URL = props["aypUrl"];
        }
    } else {
        AYP_URL = constructApiUrl( process.env.REACT_APP_AYP_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_OWNER_PROPERTIES_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["ownerPropertiesUrl"]) {
            OWNER_PROPERTIES_API_URL = props["ownerPropertiesUrl"];
        }
    } else {
        OWNER_PROPERTIES_API_URL = constructApiUrl( process.env.REACT_APP_OWNER_PROPERTIES_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_DETAIL_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["reservationDetailUrl"]) {
            RESERVATION_DETAIL_API_URL = props["reservationDetailUrl"];
        }
    } else {
        RESERVATION_DETAIL_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_DETAIL_API_URL || "");
    }
    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_DETAIL_API_URL_WEEKS) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["reservationDetailUrlWeeks"]) {
            RESERVATION_DETAIL_API_URL_WEEKS = props["reservationDetailUrlWeeks"];
        }
    } else {
        RESERVATION_DETAIL_API_URL_WEEKS = constructApiUrl( process.env.REACT_APP_RESERVATION_DETAIL_API_URL_WEEKS || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_API_CALL_TIMEOUT) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiTimeout"]) {
            API_CALL_TIMEOUT = props["apiTimeout"];
        }
    } else {
        API_CALL_TIMEOUT = constructApiUrl( process.env.REACT_APP_API_CALL_TIMEOUT || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_RESERVATION_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiResListUrl"]) {
            RESERVATION_LIST_API_URL = props["apiResListUrl"];
        }
    } else {
        RESERVATION_LIST_API_URL = constructApiUrl( process.env.REACT_APP_RESERVATION_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_WAITLIST_MANAGEMENT_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiResWaitListUrl"]) {
            WAITLIST_MANAGEMENT_LIST_API_URL = props["apiResWaitListUrl"];
        }
    } else {
        WAITLIST_MANAGEMENT_LIST_API_URL = constructApiUrl( process.env.REACT_APP_WAITLIST_MANAGEMENT_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_COUNTRY_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiCountryListUrl"]) {
            COUNTRY_LIST_API_URL = props["apiCountryListUrl"];
        }
    } else {
        COUNTRY_LIST_API_URL = constructApiUrl( process.env.REACT_APP_COUNTRY_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_ADS_API) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiAds"]) {
            ADS_API = props["apiAds"];
        }
    } else {
        ADS_API = constructApiUrl( process.env.REACT_APP_ADS_API || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_POINTS_CALCULATOR_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiPointsCalculatorUrl"]) {
            POINTS_CALCULATOR_API_URL = props["apiPointsCalculatorUrl"];
        }
    } else {
        POINTS_CALCULATOR_API_URL = constructApiUrl( process.env.REACT_APP_POINTS_CALCULATOR_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_TRANS_LIST_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiTransListUrl"]) {
            TRANSACTION_LIST_API_URL = props["apiTransListUrl"];
        }
    } else {
        TRANSACTION_LIST_API_URL = constructApiUrl( process.env.REACT_APP_TRANS_LIST_API_URL || "");
    }

    if (isNotEnvVarSet(process.env.REACT_APP_WAITLISTS_CREATE_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiWaitlistCreateUrl"]) {
            WAITLISTS_CREATE_API_URL = props["apiWaitlistCreateUrl"];
        }
    } else {
        WAITLISTS_CREATE_API_URL = constructApiUrl( process.env.REACT_APP_WAITLISTS_CREATE_API_URL || "");
    }


    if (isNotEnvVarSet(process.env.REACT_APP_OWNER_INFO_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
        if (props && props["apiOwnerInfoUrl"]) {
            OWNER_INFO_API_URL = props["apiOwnerInfoUrl"];
        }
    } else {
        OWNER_INFO_API_URL = constructApiUrl( process.env.REACT_APP_OWNER_INFO_API_URL || "");
    }

    if(isNotEnvVarSet(process.env.REACT_APP_OWNER_INFO_API_URL) ||
    [ReactAppMode.VOA].includes(EXEC_MODE)) {
        APP_DYNAMICS_KEY = process.env.REACT_APP_APP_DYNAMICS_KEY || "";
    }
    

    if(isNotEnvVarSet(process.env.REACT_APP_GUEST_TERMS_API_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            if(props && props["guestTermsUrl"]) {
                GUEST_TERMS_API_URL = props["guestTermsUrl"];
                console.log('guest url', props["guestTermsUrl"]);
            } 
    } else {
        GUEST_TERMS_API_URL = constructApiUrl(process.env.REACT_APP_GUEST_TERMS_API_URL || "");
        console.log('apiUrl', GUEST_TERMS_API_URL);
    }

    if(isNotEnvVarSet(process.env.REACT_APP_GUEST_PROFIEL_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            if(props && props["guestTermsUrl"]) {
                GUEST_PROFIEL_URL = props["guestTermsUrl"];
            } 
    } else {
        GUEST_PROFIEL_URL = constructApiUrl(process.env.REACT_APP_GUEST_PROFIEL_URL || "");
    }

    // if(isNotEnvVarSet(process.env.REACT_APP_OWNER_INFO_API_URL) ||
    // [ReactAppMode.VOA].includes(EXEC_MODE)) {
    //     TRANSFER_POINTS_CONTRACTS_URL = process.env.REACT_APP_TRANSFER_POINTS_CONTRACTS_URL || "";
    // }

    if (isNotEnvVarSet(process.env.REACT_APP_TRANSFER_POINTS_CONTRACTS_URL) ||
        [ReactAppMode.VCAP, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            //TODO: This will not work, since transfer points has not been configured for VCAP
        if (props && props["apiTranferPointsContractsUrl"]) {
            TRANSFER_POINTS_CONTRACTS_URL = props["apiTranferPointsContractsUrl"];
        }
    } else {
        console.log("Transfer points URL Mode " + EXEC_MODE);
        console.log("Transfer points URL integration mode " + INTEGRATION_MODE);
        console.log("Transfer points URL " + process.env.REACT_APP_TRANSFER_POINTS_CONTRACTS_URL);
        TRANSFER_POINTS_CONTRACTS_URL = constructApiUrl( process.env.REACT_APP_TRANSFER_POINTS_CONTRACTS_URL || "");
        console.log("Transfer points URL after" + TRANSFER_POINTS_CONTRACTS_URL);
    }
}

export default logLevel;
